import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';

import { LS_ONBOARDING_HOLDOUT_KEY, type OnboardingHoldoutState } from './constants';

export function persistState(state: OnboardingHoldoutState): void {
	try {
		AtlBrowserStorageLocal.setItem(LS_ONBOARDING_HOLDOUT_KEY, JSON.stringify(state));
	} catch {
		// AtlBrowserStorageLocal may be full or unavailable (e.g. private browsing in Safari)
	}
}
